import type { ClientTokenResponse } from './tokenResponse';

/**
 * Extracts a property value from the additionalParameters bag in a ClientTokenResponse
 * @param tokenResponse The token response containing additionalParameters
 * @param paramName The name of the parameter to extract (case-insensitive)
 * @returns The value of the parameter if found, undefined otherwise
 */
export const extractPropertyFromBag = (
    tokenResponse: ClientTokenResponse,
    paramName: string
): string | undefined =>
    tokenResponse?.additionalParameters?.find(
        ({ name }) => name.toLowerCase() === paramName.toLowerCase()
    )?.value;
